<template>
  <div class="flex xs12">
    <va-card :title="$t('forms.inputs.PalletizedProducts') + ' ' + this.$route.params.loadCode">
      <va-button
        v-if="this.$route.params.assemblyLine == 10"
        medium
        inline
        color="#ff842b"
        icon="fa fa-chevron-left"
        class="ma-2"
        :to="{ name: 'loads_finished', params: {
          current_page: this.$route.params.current_page,
          search: this.$route.params.search,
          delivery_date: this.$route.params.delivery_date,
          perPage: this.$route.params.perPage }
          }"
      >
          {{ $t('menu.back') }}
      </va-button>
      <va-button
        v-if="this.$route.params.assemblyLine == 9"
        small
        inline
        color="#ff842b"
        icon="fa fa-chevron-left"
        class="ma-0"
        :to="{ name: 'loads', params: {
          current_page: this.$route.params.current_page,
          search: this.$route.params.search,
          delivery_date: this.$route.params.delivery_date,
          perPage: this.$route.params.perPage }
          }"
      >
      {{ $t('menu.back') }}
    </va-button>
    <va-button
        v-if="this.$route.params.assemblyLine == 11"
        small
        inline
        color="#ff842b"
        icon="fa fa-chevron-left"
        class="ma-0"
        :to="{ name: 'load_palletizing', params: {
          current_page: this.$route.params.current_page,
          search: this.$route.params.search,
          delivery_date: this.$route.params.delivery_date,
          perPage: this.$route.params.perPage }
          }"
      >
      {{ $t('menu.back') }}
    </va-button>

    <div v-show="loading" class="text--center pb-4">
      <div class="flex-center spinner-box">
        <slot name="loading">
          <spring-spinner
            slot="loading"
            :animation-duration="currentDuration"
            :is="spload.name"
            :color="spinnersColor"
            :size="config.size"
          />
        </slot>
      </div>
    </div>

      <va-data-table
        :fields="fields"
        :data="palletizedProducts"
        no-pagination
        v-show="!loading"
      />
    </va-card>
  </div>
</template>

<script>

import PalletizedProductsAPI from '@/services/PalletizedProductsAPI'

import * as spinners from 'epic-spinners'

export default {
  components: {
    ...spinners,
  },
  data () {
    return {
      palletizedProducts: [],
      loading: false,
      config: {
        size: 80,
        group: 4,
        duration: 1500,
      },
      spinnersColor: this.$themes.secondary,
      currentDuration: 1500,
      showModalRemove: false,
    }
  },

  mounted () {
    this.getPalletizedProducts()
  },

  computed: {
    fields () {
      return [{
        name: 'bay_name',
        title: this.$t('tables.PalletizedProducts.bay_name'),
      },
      {
        name: 'product_name',
        title: this.$t('tables.PalletizedProducts.product_name'),
      },
      {
        name: 'quantity',
        title: this.$t('tables.PalletizedProducts.quantity'),
        width: '3%',
      },
      {
        name: 'box',
        title: this.$t('tables.PalletizedProducts.box'),
        width: '3%',
      },
      {
        name: 'bay_percentage',
        title: this.$t('tables.PalletizedProducts.bay_percentage'),
      },
      {
        name: 'pallet_percentage',
        title: this.$t('tables.PalletizedProducts.pallet_percentage'),
      },
      {
        name: 'product_group_name',
        title: this.$t('tables.PalletizedProducts.product_group_name'),
        width: '10%',
      },
      {
        name: 'package_name',
        title: this.$t('tables.PalletizedProducts.package_name'),
        width: '10%',
      },
      {
        name: 'ballast',
        title: this.$t('tables.PalletizedProducts.ballast'),
      },
      {
        name: 'full_pallet',
        title: this.$t('tables.PalletizedProducts.full_pallet'),
        width: '3%',
      }]
    },
    spload () {
      return spinners.ScalingSquaresSpinner
    },
  },
  methods: {
    getPalletizedProducts () {
      this.loading = true
      PalletizedProductsAPI.getPalletizedProductsByLoadID(this.$route.params.loadID).then(response => {
        this.palletizedProducts = response.data.palletized_products
        this.loading = false
      })
    },
  },
}
</script>
